import { useState, useEffect } from 'react';
import AzureAuthService from '../Services/AzureAuthService';

export interface AzureUser {
  id: string;
  username: string;
  name: string | undefined;
  email: string;
}

export const useAzureAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<AzureUser | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        await AzureAuthService.initialize();

        if (AzureAuthService.isAuthenticated()) {
          setIsAuthenticated(true);
          setUser(AzureAuthService.getUserInfo());
        }
      } catch (err) {
        console.error('Erro ao inicializar autenticação:', err);
        setError('Erro ao inicializar autenticação');
      }
    };

    initializeAuth();
  }, []);

  const login = async (usePopup = true) => {
    setIsLoading(true);
    setError(null);

    try {
      if (usePopup) {
        const result = await AzureAuthService.loginWithPopup();
        if (result) {
          setIsAuthenticated(true);
          setUser(AzureAuthService.getUserInfo());
          return result;
        }
      } else {
        await AzureAuthService.loginWithRedirect();
      }
    } catch (err: any) {
      console.error('Erro no login:', err);
      setError(err.message || 'Erro no login SSO');
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const logout = async () => {
    try {
      await AzureAuthService.logout();
      setIsAuthenticated(false);
      setUser(null);
    } catch (err: any) {
      console.error('Erro no logout:', err);
      setError(err.message || 'Erro no logout');
    }
  };

  const getAccessToken = async () => {
    try {
      return await AzureAuthService.getAccessToken();
    } catch (err) {
      console.error('Erro ao obter token:', err);
      return null;
    }
  };

  return {
    isAuthenticated,
    user,
    isLoading,
    error,
    login,
    logout,
    getAccessToken,
  };
};
